/**
 * Application route constants
 * Centralized location for all route paths to ensure consistency
 */

// Trading recommendation routes (user-facing)
export const TRADING_ROUTES = {
  KERNSTRATEGIE: '/signale/kernstrategie',
  EARNING_TRADES: '/signale/earning-trades',
  SWING_TRADES: '/signale/swing-trades',
  LONGTERM_TRADES: '/signale/langzeit-trades',

  // Detail pages - functions for generating links
  CORE_RECOMMENDATION_DETAIL: (id: string) => `/signale/core-recommendations/${id}`,
  EARNINGS_RECOMMENDATION_DETAIL: (id: string) => `/signale/earnings-recommendations/${id}`,
  SWING_TRADE_DETAIL: (id: string) => `/signale/swing-trades/${id}`,
  LONG_TERM_TRADE_DETAIL: (id: string) => `/signale/long-term-trades/${id}`,

  // Detail page patterns - for React Router route definitions
  CORE_RECOMMENDATION_DETAIL_PATTERN: '/signale/core-recommendations/:recommendationId',
  EARNINGS_RECOMMENDATION_DETAIL_PATTERN: '/signale/earnings-recommendations/:recommendationId',
  SWING_TRADE_DETAIL_PATTERN: '/signale/swing-trades/:recommendationId',
  LONG_TERM_TRADE_DETAIL_PATTERN: '/signale/long-term-trades/:recommendationId',

  // Base paths for URL matching
  CORE_RECOMMENDATIONS_BASE: '/core-recommendations/',
  EARNINGS_RECOMMENDATIONS_BASE: '/earnings-recommendations/',
  SWING_TRADES_BASE: '/swing-trades/',
  LONG_TERM_TRADES_BASE: '/long-term-trades/',
} as const;

// Admin trading recommendation routes
export const ADMIN_TRADING_ROUTES = {
  LIST: '/admin/trading-recommendations',

  // List pages per type
  CORE_LIST: '/admin/trading-recommendations/core-recommendations',
  EARNINGS_LIST: '/admin/trading-recommendations/earnings-recommendations',
  SWING_LIST: '/admin/trading-recommendations/swing-trades',
  LONG_TERM_LIST: '/admin/trading-recommendations/long-term-trades',

  // Detail pages - functions for generating links (admin full detail)
  CORE_RECOMMENDATION_DETAIL: (id: string) => `/admin/trading-recommendations/core-recommendations/${id}`,
  EARNINGS_RECOMMENDATION_DETAIL: (id: string) => `/admin/trading-recommendations/earnings-recommendations/${id}`,
  SWING_TRADE_DETAIL: (id: string) => `/admin/trading-recommendations/swing-trades/${id}`,
  LONG_TERM_TRADE_DETAIL: (id: string) => `/admin/trading-recommendations/long-term-trades/${id}`,

  // Detail page patterns - for React Router route definitions
  CORE_RECOMMENDATION_DETAIL_PATTERN: '/admin/trading-recommendations/core-recommendations/:recommendationId',
  EARNINGS_RECOMMENDATION_DETAIL_PATTERN: '/admin/trading-recommendations/earnings-recommendations/:recommendationId',
  SWING_TRADE_DETAIL_PATTERN: '/admin/trading-recommendations/swing-trades/:recommendationId',
  LONG_TERM_TRADE_DETAIL_PATTERN: '/admin/trading-recommendations/long-term-trades/:recommendationId',
} as const;

// Day trading routes
export const DAY_TRADING_ROUTES = {
  LIST: '/daytrading',
  PARTICIPATE: (id: string) => `/daytrading/${id}/participate`,
  PARTICIPATE_PATTERN: '/daytrading/:sessionId/participate',
  MODERATE: (id: string) => `/daytrading/${id}/moderate`,
  MODERATE_PATTERN: '/daytrading/:sessionId/moderate',
  OBSERVE: (id: string) => `/daytrading/${id}/observe`,
  OBSERVE_PATTERN: '/daytrading/:sessionId/observe',
  CHAT: (id: string) => `/daytrading/${id}/chat`,
  CHAT_PATTERN: '/daytrading/:sessionId/chat',
  LIVESTREAM: '/daytrading/livestream',
  LIVESTREAM_PATTERN: '/daytrading/livestream',
} as const;

// Option screener routes
export const OPTION_SCREENER_ROUTES = {
  LIST: '/option-screener',
  DETAIL: (id: string) => `/option-screener/${id}`,
  DETAIL_PATTERN: '/option-screener/:contractId',
} as const;

// Market analysis routes
export const MARKET_ROUTES = {
  ANALYSIS: '/market-analysis',
} as const;

// Trading journal routes
export const JOURNAL_ROUTES = {
  DASHBOARD: '/journal',
  TRADES: '/journal/trades',
  TRADE_DETAIL: (id: string) => `/journal/trades/${id}`,
  TRADE_DETAIL_PATTERN: '/journal/trades/:tradeId',
  POSITIONS: '/journal/positions',
  CALENDAR: '/journal/calendar',
  CAPITAL_LADDER: '/journal/capital-ladder',
  ASSIGNMENTS: '/journal/assignments',
  REVIEWS: '/journal/reviews',
  TAGS: '/journal/tags',
  IMPORT: '/journal/import',
  SETTINGS: '/journal/settings',
} as const;
